// extracted by mini-css-extract-plugin
export default {"navigationButton":"infinite-pagination_navigationButton__vdJeR","navigationButtonIcon":"infinite-pagination_navigationButtonIcon__d8AvQ"};